const language = "chinese";
export const langDir = "ltr";

export default language;
